<template>
  <div>
      <banner-top :text="titletext"></banner-top>
      <div class="bg"></div>
      <div style="width: 100%!important;">
        <el-upload
          action=""
          :show-file-list="false"
          :http-request="uploadImg"
        >
          <div class="flexa">
            <div class="title">头像</div>
            <div>
              <img v-if="res.head" class="pictitle" :src="res.head" alt="">
              <img v-else class="pictitle" src="../assets/icon42.png" alt="">
              <img class="next" src="../assets/icon27.png" alt="">
            </div>
            </div>
        </el-upload>
        <div class="flex" style="border: 0!important;">
          <div class="title">昵称</div>
          <el-input v-model="res.nickname" class="inputTitle"></el-input>
        </div>
        <div class="space"></div>
        <div class="flex">
          <div class="title">账号</div>
          <div class="title">{{res.username}}</div>
        </div>
        <div class="flex" @click="toBinding('phone')">
          <div class="title">手机</div>
          <div class="title">{{res.phone?res.phone:'未绑定'}}</div>
        </div>
        <div class="flex" style="border: 0!important;" @click="toBinding('mail')">
          <div class="title">邮箱</div>
          <div class="title">{{res.email?res.email:'未绑定'}}</div>
        </div>
      </div>
      <div class="nav">
        <button @click="save">保存</button>
    </div>
    <!-- <el-drawer
      :visible.sync="drawer"
      direction="btt"
      :before-close="handleClose">
      <div class="drawer">
        <div style="border-bottom:1px solid #666">拍照</div>
        <div>从相册中选取</div>
      </div>
    </el-drawer> -->
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'personal',
  components: { bannerTop },
  data () {
    return {
      drawer: false,
      titletext: '个人信息',
      res: Object
    }
  },
  created () {
    http['get']('account').then((res) => { this.res = res })
  },
  methods: {
    toBinding (tem) {
      if (tem === 'phone') {
        if (this.res.phone) {
          this.$router.push({name: 'binding', query: { type: tem, flag: true }})
        } else {
          this.$router.push({name: 'binding', query: { type: tem, flag: false }})
        }
      } else {
        if (this.res.email) {
          this.$router.push({name: 'binding', query: { type: tem, flag: true }})
        } else {
          this.$router.push({name: 'binding', query: { type: tem, flag: false }})
        }
      }
    },
    save () {
      http['put']('account', {nickname: this.res.nickname})
      this.$router.push({name: 'mine'})
    },
    uploadImg (item) {
      const fileObj = item.file
      // FormData 对象
      const form01 = new FormData()
      // 文件对象()
      form01.append('head', fileObj)
      http['put']('account/head', form01)
      http['get']('account').then((res) => { this.res = res })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
    position: absolute;
    width: 100%;
    height: 110%;
    top: -10%;
    background: #f5f5f5;
    z-index: -1;
}
.flexa {
  width: 100%;
  background-color: #fff;
  display: flex!important;
  justify-content: space-between;
  border-bottom: 1px #ddd solid;
}
.flexa .title {
  font-size: 20px;
  margin: 2.5rem 1.2rem ;
}
.pictitle {
    width: 4rem;
    height: 4rem;
    margin: 1.2rem;
    border-radius: 50%;
}
.next {
    margin-bottom: 2rem;
    margin-right: 0.6rem;
}
.flex {
  width: 100%;
  height: 4rem;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #ddd solid;
}
.flex .title {
  font-size: 20px;
  margin: 1.2rem;
}
.flex .inputTitle {
  width: 2rem;
  text-align: right;
}
.flex>>>.el-input {
  width: 14rem;
  margin-top: 0.7rem;
}
.flex>>>.el-input__inner {
  text-align: right;
  border: 0;
  font-size: 18px;
}
.space {
    width: 100%;
    height: 1.2rem;
    background: #f5f5f5;
}
.nav {
  width: 100%;
  height: 3.2rem;
  display: flex;
  position:fixed;
  justify-content: center;
  bottom: 0;
}
.nav button {
    width: 80%;
    height: 2.8rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
.drawer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}
.drawer div {
  width: 80%;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  padding: 1rem;
}
</style>
<style>
.el-upload {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/mine/personal.vue